import { theme } from 'antd';
import { CalendarIcon, InfoIcon, Maintenance } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectDevicesByDeviceID } from 'reduxStore/devices/selectors';
import { CreateBookingModal, LockerDrawer, MaintenanceDeviceDrawer } from 'zComponents/molecules';
import { Button, Divider, Dropdown, Flex, Typography } from 'zui/Antd';
const { Text } = Typography;

const LockerDropdown = ({ children, deviceID, isTransparent = false }) => {
	// ✅ Hooks
	const {
		token: {
			colorBgContainer,
			boxShadow,
			borderRadius,
			padding,
			paddingSM,
			fontSizeLG,
			colorPrimaryText,
			fontWeightStrong
		}
	} = theme.useToken();

	// ✅ Redux States
	const locker = useSelector((state) => selectDevicesByDeviceID(state, deviceID));

	// ✅ Permissions
	const canAddBooking = useManagePermittedRoles('addBooking');

	// ✅ Local States
	const [openDropdown, setOpenDropdown] = useState(false);
	const [openLockerDrawer, setOpenLockerDrawer] = useState(false);
	const [openMaintenanceDrawer, setOpenMaintenanceDrawer] = useState(false);

	const items = [
		{
			key: 'View Locker',
			label: (
				<Button
					type='text'
					icon={<InfoIcon />}
					block
					onClick={() => setOpenLockerDrawer(true)}
					style={{
						justifyContent: 'flex-start',
						fontWeight: fontWeightStrong
					}}
				>
					View Locker
				</Button>
			)
		},
		{
			key: 'Create Booking',
			label: (
				<CreateBookingModal deviceID={deviceID}>
					<Button
						type='text'
						icon={<CalendarIcon />}
						block
						disabled={!canAddBooking}
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
					>
						Create Booking
					</Button>
				</CreateBookingModal>
			)
		},
		{
			key: 'Log Maintenance',
			label: (
				<Button
					type='text'
					icon={<Maintenance />}
					block
					style={{
						justifyContent: 'flex-start',
						fontWeight: fontWeightStrong
					}}
					onClick={() => setOpenMaintenanceDrawer(true)}
				>
					Log Maintenance
				</Button>
			)
		}
	];

	return (
		<>
			<Dropdown
				trigger={['click']}
				placement='bottomLeft'
				open={openDropdown}
				onOpenChange={(visible) => setOpenDropdown(visible)}
				dropdownRender={() => (
					<Flex
						style={{
							backgroundColor: colorBgContainer,
							borderRadius: borderRadius,
							width: 240,
							boxShadow: boxShadow,
							padding: `${padding}px ${paddingSM}px`,
							position: 'relative'
						}}
						vertical
					>
						<Text style={{ fontWeight: fontWeightStrong, fontSize: fontSizeLG, lineHeight: '24px' }}>
							{locker.name}
						</Text>
						<Divider style={{ margin: `10px 0px` }} />
						<Flex vertical gap={paddingSM} style={{ marginTop: 10 }}>
							{items.map((item) => (
								<div key={item.key} onClick={() => setOpenDropdown(false)}>
									{item.label}
								</div>
							))}
						</Flex>
					</Flex>
				)}
			>
				{children ? (
					children
				) : (
					<Button
						type={isTransparent ? 'text' : 'primary'}
						style={{ color: isTransparent && colorPrimaryText }}
					>
						{isTransparent ? 'View' : 'Manage'} Locker
					</Button>
				)}
			</Dropdown>

			<LockerDrawer visible={openLockerDrawer} setVisible={setOpenLockerDrawer} deviceID={deviceID} />
			<MaintenanceDeviceDrawer
				deviceID={deviceID}
				visible={openMaintenanceDrawer}
				setVisible={setOpenMaintenanceDrawer}
			>
				<div />
			</MaintenanceDeviceDrawer>
		</>
	);
};

export default LockerDropdown;
